import { useMyCoachProfile } from '@/hooks/useMyCoachProfile'
import { useRole } from '@/hooks/useRole'
import { ClerkUserRole } from '@/types/auth'

export type OwnCoachWorkspace = {
  /** False until the role, and for a coach their profile, has resolved. */
  readonly isLoaded: boolean
  /** Whether the signed-in user has a coaching workspace of their own. */
  readonly hasOwnCoachWorkspace: boolean
  /** Whether they receive coaching work. False for onboarding-only staff, who have no meetings, hours or public profile. */
  readonly receivesCoaching: boolean
}

/**
 * The one place that answers whether the viewer has a workspace of their own, and what kind of work it holds.
 * Not an authorization check: `ROUTE_ACCESS_CONFIG` and the API decide access.
 */
export function useHasOwnCoachWorkspace(): OwnCoachWorkspace {
  const { userRole, isLoaded: roleLoaded } = useRole()
  const isCoach = roleLoaded && userRole === ClerkUserRole.COACH
  const { profile, isLoading, loadError } = useMyCoachProfile(isCoach)

  // A profile that fails to load keeps the coaching surfaces, which is how the portal behaved before designation.
  const receivesCoaching = !profile || profile.assignment_kinds.includes('coaching')

  return {
    isLoaded: roleLoaded && (!isCoach || !isLoading || Boolean(loadError)),
    hasOwnCoachWorkspace: isCoach,
    receivesCoaching: isCoach && receivesCoaching,
  }
}
